import { Form, Field } from 'redux-form';

import AddressForm from 'common/components/address/AddressForm';
import { CheckBox } from 'common/components/forms';

const AddEditForm = (props) => {
  const {
    onSubmit,
    saveButtonText,
    object,
    changeFunction,
    isFirstAddress,
    settings
  } = props;
  if (!object) {
    return null;
  }
  const handleCancel = (e) => {
    e.preventDefault();
    props.onCancelFunction();
  };

  const showDefaultCheckbox = () => {
    if (isFirstAddress) {
      return null;
    }
    return (
      <Field
        name="isDefault"
        component={CheckBox}
        type="checkbox"
        value="1"
        label="Default Address"
      />
    );
  };

  return (
    <Form onSubmit={onSubmit} className="c7-form" method="post">
      <AddressForm
        object={object}
        changeFunction={changeFunction}
        settings={settings}
      />

      {showDefaultCheckbox()}

      <div className="c7-form__button-row">
        <a onClick={handleCancel} className="c7-button-alt">
          Cancel
        </a>
        <button type="submit" className="c7-button">
          {saveButtonText}
        </button>
      </div>
    </Form>
  );
};

export default AddEditForm;
